import React, {Component} from 'react';
import {Grid} from '@material-ui/core';
import axios from "axios/index";

import _ from "lodash";
import Select from '../common/select'

import slp from "../../../assets/SLP.png";
import people from "../../../assets/people.png";
import latam from "../../../assets/latam.png";
import station from "../../../assets/station.png";
import fuel from "../../../assets/fuel.png";
import urls from "../../../utils/urls";
import {tokenHeader} from "../../../utils/headers";
import {ajaxHandler} from "../../../utils/errors";
import helpers from "../../../utils/helpers";
import LoadingSpinner from "../../../components/spinner/Spinner";


import './styles.scss';
import SegmentLoyalty from "./components/segmentLoyalty/SegmentLoyalty";
import {connect} from "react-redux";

class AssociatesBehavior extends Component {

    constructor(props) {
        super(props);
        this.state = {
            associatesData: false,
            stationData: false
        }
    }

    _fetchData() {
        this._fetchAssociatesData();
        this._fetchStationsData();
    }

    componentDidMount(){
        if (this.props.stations.list) {
            if (this.props.filters) {
                this.setState({selectedValue: this.props.filters[this.props.filters.length - 1], data: false}, () => {
                    this._fetchData();
                })
            }

            if (this.state.selectedValue) {
                if ((this.props.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (this.props.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (this.props.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this._fetchData();
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.stations.list) {
            if (nextProps.filters) {
                this.setState({selectedValue: nextProps.filters[nextProps.filters.length - 1], data: false}, () => {
                    this._fetchData();
                })
            }

            if (this.state.selectedValue) {
                if ((nextProps.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (nextProps.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (nextProps.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this._fetchData();
                }
            }
        }
    }

    onValueChange = (ev) => {
        this.setState({selectedValue: ev.target.value}, () => {
            this._fetchData()
        })
    };

    _fetchAssociatesData = () => {
        let associates_url = `${urls.API_ROOT}/api/v1/segment-details/?quarter=${this.state.selectedValue.quarter}&year=${this.state.selectedValue.year}`;

        if (this.props.navigation.selectedArea !== -1) {
            associates_url = associates_url.concat(`&area_id=${this.props.navigation.selectedArea}`);
        }
        if (this.props.navigation.selectedZone !== -1) {
            associates_url = associates_url.concat(`&zone_id=${this.props.navigation.selectedZone}`);
        }
        if (this.props.navigation.selectedStation !== -1) {
            associates_url = associates_url.concat(`&global_code=${this.props.navigation.selectedStation}`);
        }
        axios
            .get(associates_url, tokenHeader())
            .then((response) => this.setState({associatesData: response.data}))
            .catch(ajaxHandler);
    };

    _fetchStationsData = () => {
        const stations_data_url = `${urls.API_ROOT}/api/v1/loyalty-info/?quarter=${this.state.selectedValue.quarter}&year=${this.state.selectedValue.year}&global_code=${this.props.navigation.selectedStation}`;
        axios
            .get(stations_data_url, tokenHeader())
            .then((response) => this.setState({stationData: response.data}))
            .catch(ajaxHandler);
    };

    render() {
        let members_variation = this.state.associatesData.members_variation ? helpers.getThousandCommaNumber(this.state.associatesData.members_variation) : 0;
        let lts_variation = this.state.associatesData.lts_variation ? helpers.getThousandCommaNumber(this.state.associatesData.lts_variation) : 0;

        let member_variation_text = members_variation > 0 ? `+${members_variation}` : members_variation;
        let lts_variation_text = lts_variation > 0 ? `+${lts_variation}` : lts_variation;

        let one_station_member = _.find(this.state.stationData, ['type', "one_station_members"]);
        let two_station_member = _.find(this.state.stationData, ['type', "two_station_members"]);
        let three_or_more_station_member = _.find(this.state.stationData, ['type', "three_or_more_station_members"]);

        let total_members = 1;
        if (one_station_member && two_station_member && three_or_more_station_member) {
            total_members = one_station_member.members + two_station_member.members + three_or_more_station_member.members;
        }

        const values = this.props.filters;
        let registeredAssociates = this.state.associatesData ? (this.state.associatesData.registered_members * 100) / this.state.associatesData.total_members : 0;

        return (
            <div className={"container"}>
                <div className={"select-category"} style={{textAlign: 'right'}}>
                    <Select className={"select"} values={values} selectedValue={this.state.selectedValue}
                            onValueChange={this.onValueChange}/>
                </div>
                {this.state.associatesData &&
                <div className={"padding-30"}>
                    <div className={"subtitle-select"}>
                        <div className={"subtitle"}>¿Cuántos socios cargaron en el trimestre?</div>
                        <div className={"subtitle"} style={{width: '23%', marginLeft: 20}}>¿Cuántos litros cargaron?
                        </div>
                    </div>

                    <Grid container spacing={16}>
                        <Grid item xs={3}>
                            <div className={"section-total"}>
                                <img src={slp} className={"img-slp"}/>
                                <div
                                    className={"value"}>{helpers.getThousandCommaNumber(this.state.associatesData.total_members)}</div>
                                <div className={"description"}>Socios Totales</div>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className={"section-register-associates"}>
                                <div className={"registered"}>
                                    <img src={people} className={"img-people"}/>
                                    <div className={"border-left"}>
                                        <div
                                            className={"value"}>{helpers.getThousandCommaNumber(this.state.associatesData.registered_members)}</div>
                                        <div className={"description"}>Socios Registrados
                                            ({helpers.getThousandCommaNumber(_.round(registeredAssociates, 1))}%)
                                        </div>
                                    </div>
                                </div>
                                <div className={"variation"}>
                                    <img src={latam} className={"img-latam"}/>
                                    <div className={"value blue"}>{member_variation_text}</div>
                                    <div className={"description"}>Socios Registrados vs. trimestre anterior
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className={"section-fuel"}>
                                <img src={fuel} className={"img-fuel"}/>
                                <div className={"data"}>
                                    <div className={"border-left width-60"}>
                                        <div
                                            className={"value"}>{helpers.getThousandCommaNumber(this.state.associatesData.lts_per_associate)} lts.
                                        </div>
                                        <div className={"description"}>Por socio</div>
                                    </div>
                                    <div>
                                        <div className={"value blue"}>{lts_variation_text} lts</div>
                                        <div className={"description"}>Vs. trimestre anterior</div>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>}

                {!this.state.associatesData &&
                <div style={{marginTop: 70}}>
                    <LoadingSpinner className={'spinner'} width={50}/>
                </div>
                }
                {this.props.navigation.selectedStation !== -1 && this.state.stationData &&
                <div className="padding-30">
                    <div className={"subtitle-select no-padding column"}>
                        <div className={"subtitle "}>¿Dónde cargaron y cuántos litros en cada EESS?</div>
                        <div className={"subtitle no-bold"}>Apertura por lealtad a la boca</div>
                    </div>

                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <div className={"section-loyalty"}>
                                <img src={station} className={"img-station"}/>
                                <SegmentLoyalty mainValue={helpers.getThousandCommaNumber(one_station_member.members)}
                                                percentage={_.round(one_station_member.members * 100 / total_members, 1)}
                                                comment={"Cargaron únicamente en su boca"}
                                                percentageVolume={_.round(one_station_member.percentage,1)} key={"A"} key2={"B"}/>
                                <SegmentLoyalty mainValue={helpers.getThousandCommaNumber(two_station_member.members)}
                                                percentage={_.round(two_station_member.members * 100 / total_members, 1)}
                                                comment={"Cargaron en 2 o 3 bocas"}
                                                percentageVolume={_.round(two_station_member.percentage,1)} key={"C"} key2={"D"}/>
                                <SegmentLoyalty
                                    mainValue={helpers.getThousandCommaNumber(three_or_more_station_member.members)}
                                    percentage={_.round(three_or_more_station_member.members * 100 / total_members, 1)}
                                    comment={"Cargaron en 4 o más bocas"}
                                    percentageVolume={_.round(three_or_more_station_member.percentage,1)} key={"E"} key2={"F"}/>
                            </div>
                            <div className={"clarification"}>(*) Volumen cargado por los socios en su boca sobre el
                                total que cargaron
                            </div>

                        </Grid>

                    </Grid>
                </div>}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        filters: state.filters,
        navigation: state.navigation,
        stations: state.stations
    }
};

export default connect(mapStateToProps)(AssociatesBehavior);



// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/associatesBehavior/AssociatesBehavior.js